module.exports = __webpack_public_path__ + "img/portfolio-05-481x325.9e056051.jpg";